import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, resolveDynamicComponent as _resolveDynamicComponent, unref as _unref, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-338ffcbd"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("svg", {
    class: "absolute size-80",
    viewBox: "0 0 80 80"
}, [
    /*#__PURE__*/ _createElementVNode("circle", {
        cx: "40",
        cy: "40",
        r: "32",
        class: "Dashes stroke-black",
        fill: "none",
        "stroke-dasharray": "4 8"
    })
], -1));
import { computed, onBeforeUnmount, onMounted, ref } from "vue";
import useGSAP from "@/composables/useGSAP";
import frames from "@/utils/frameToTime";
export default /*#__PURE__*/ _defineComponent({
    __name: 'UIRoundCta',
    props: {
        text: {},
        as: { default: "button" },
        variant: { default: "default" },
        hover: { type: Boolean },
        delay: { default: 0 },
        sound: { type: [String, Boolean], default: "UI_CLICK" }
    },
    setup(__props) {
        _useCssVars(_ctx => ({
            "8dcddd3c": (props.delay)
        }));
        const props = __props;
        const gsap = useGSAP();
        const icon = computed(() => props.variant === "map" ? "cross" : "symbol");
        const root = ref(null);
        let ctx;
        const setup = (self) => {
            self.add("onHover", (isHover = true) => {
                gsap.to(".Text .Inner", {
                    rotation: isHover ? "+=45" : undefined,
                    scale: isHover ? 0.93 : 1,
                    duration: frames(60),
                    ease: "quint.out"
                });
            });
        };
        onMounted(() => {
            if (!root.value)
                return;
            ctx = gsap.context(setup, root.value);
        });
        onBeforeUnmount(() => {
            ctx === null || ctx === void 0 ? void 0 : ctx.kill();
        });
        return (_ctx, _cache) => {
            const _component_UIIcon = _resolveComponent("UIIcon");
            const _component_UICircularText = _resolveComponent("UICircularText");
            const _directive_cursor = _resolveDirective("cursor");
            const _directive_sound = _resolveDirective("sound");
            return (_openBlock(), _createBlock(_Transition, {
                duration: 1000 + _ctx.delay * 1000,
                appear: ""
            }, {
                default: _withCtx(() => [
                    _withDirectives((_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.as), {
                        ref_key: "root",
                        ref: root,
                        class: _normalizeClass(["UIRoundCta relative flex justify-center items-center rounded-full focus:outline-none *:pointer-events-none", [`UIRoundCta--${_ctx.variant}`, { hover: _ctx.hover }]]),
                        type: _ctx.$attrs.type || (_ctx.as === 'button' ? 'button' : undefined),
                        onMouseenter: _cache[0] || (_cache[0] = ($event) => { var _a; return ((_a = _unref(ctx)) === null || _a === void 0 ? void 0 : _a.onHover(true)); }),
                        onMouseleave: _cache[1] || (_cache[1] = ($event) => { var _a; return ((_a = _unref(ctx)) === null || _a === void 0 ? void 0 : _a.onHover(false)); })
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_UICircularText, {
                                class: "Text relative z-1 size-112",
                                text: _ctx.text
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_UIIcon, {
                                        class: "Icon relative",
                                        name: icon.value
                                    }, null, 8, ["name"])
                                ]),
                                _: 1
                            }, 8, ["text"]),
                            _hoisted_1
                        ]),
                        _: 1
                    }, 40, ["class", "type"])), [
                        [
                            _directive_cursor,
                            void 0,
                            void 0,
                            { hover: true }
                        ],
                        [
                            _directive_sound,
                            _ctx.sound,
                            void 0,
                            {
                                hover: true,
                                click: true
                            }
                        ]
                    ])
                ]),
                _: 1
            }, 8, ["duration"]));
        };
    }
});
